import gql from "graphql-tag";

export const DELETE_CREW_MUTATION = gql`
  mutation deleteCrew($jobNumber: Int!, $crewCode: String!){
    deleteCrew(jobNumber: $jobNumber, crewCode: $crewCode)
  }
`;